/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { useState, type ReactNode, useEffect } from 'react';
import { Link } from '@mui/material';
import type { IssueTrackerLinkProps } from './types';

export function IssueTrackerLink( { children, labels = [], useTemplate = true }: IssueTrackerLinkProps ): ReactNode {
	const [ issueTrackerRef, setIssueTrackerRef ] = useState<HTMLAnchorElement | null>( null );

	useEffect( () => {
		if ( !issueTrackerRef ) {
			return;
		}

		if ( !useTemplate ) {
			return;
		}

		const hrefUrl = new URL( issueTrackerRef.href );

		hrefUrl.searchParams.set( 'user-agent', navigator.userAgent );
		hrefUrl.searchParams.set( 'labels', [ 'squad:platform', ...labels ].join( ',' ) );

		issueTrackerRef.href = hrefUrl.toString();
	}, [ issueTrackerRef, labels, useTemplate ] );

	// @ts-expect-error REPORT_ISSUE_URL variable is injected by vite.
	const issueTrackerUrl = new URL( REPORT_ISSUE_URL );

	if ( !useTemplate ) {
		issueTrackerUrl.searchParams.delete( 'template' );
		issueTrackerUrl.pathname += '/choose';
	}

	return (
		<Link
			href={ issueTrackerUrl.toString() }
			ref={ setIssueTrackerRef }
			target='_blank'
		>
			{ children }
		</Link>
	);
}
